import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthState } from '@trtl/portal/auth';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AdminApi } from './admin.api';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const router = inject(Router);
  const api = inject(AdminApi);

  return next(req.clone({
    headers: req.headers.set('Authorization', `Bearer ${AuthState.accessToken()}`),
  })).pipe(
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 401:
        case 403:
          return api.refreshToken(AuthState.refreshToken()!).pipe(
            switchMap(() => next(req.clone({
              headers: req.headers.set('Authorization', `Bearer ${AuthState.accessToken()}`),
            }))),
            catchError(err => from(router.navigate(['/auth/logout'])).pipe(
              switchMap(() => throwError(() => err)),
            )),
          );
      }

      return throwError(() => error);
    }),
  );
}
